import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import { useStoreSelector } from 'v3/data/store';
import { setContractStepperState } from 'v3/data/store/contractCard/stepper/actions';
import { ContractStepperEnum } from 'v3/data/store/contractCard/stepper/enum';
import { ContractingStateEnum } from 'v3/data/store/contracting/enums';
import { showErrorDialog } from 'v3/data/store/error/actions';
import { showSnackbar } from 'v3/data/store/snackbar/actions';
import { updateNavigationStepByContractingState } from 'v3/pages/Contracting/Details/Cards/ContractInformation/Steps/state-navigation-mapping';
import * as api from 'v3/services/api';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { theme } from 'v3/styles/global-styles';
import { ContentStyled } from './styles';

export const DownloadPreContract = ({
  setDowloadPreContractAvailable,
}: {
  setDowloadPreContractAvailable: Function;
}) => {
  const { contractingKey, contractingState } = useStoreSelector((store) => store.contracting);
  const { device } = useStoreSelector((store) => store);

  const handleSaveClick = async () => {
    setDowloadPreContractAvailable(false);

    try {
      const response = await api.getCbbPreviewByContractingKey(contractingKey);

      if (response.data.termLink) {
        window.open(response.data.termLink, '_blank');
      }

      showSnackbar('Download do contrato iniciado!', 'success', true);
      setContractStepperState({
        stepName: ContractStepperEnum.PreContract,
        error: false,
        isCompleted: true,
      });

      updateNavigationStepByContractingState(contractingState, Boolean(device.imei), false, true);
    } catch (error) {
      showErrorDialog('Erro ao baixar pré-contrato', error);
    }
  };

  return (
    <ContentStyled>
      <FlexButton
        handleClick={handleSaveClick}
        $outline
        $backgroundColor="none"
        text="Baixar pré-contrato"
        startIcon={LocalPrintshopOutlinedIcon}
        disabled={contractingState.includes(ContractingStateEnum.ProcessingAntiFraud)}
      />

      <BodySmallRegular color={theme.palette.secondary.light}>
        Baixe o pré-contrato, realize a emissão da NFe no Controle Celular para prosseguir
      </BodySmallRegular>
    </ContentStyled>
  );
};
